var ShapeBtn = require('./shapeButton');

module.exports = ShapeBtn.extend({
    iconCode: 0xe80d,
    color: '#ff0000',
    title: 'Delete',
    clickAction: function(e) { //delete the shape

        e = $.event.fix(e);
        e.stopImmediatePropagation();

        // want inline require ? -- could make fn that returns the constructor or pass it in as arg
        var SignatureShape =  require('../../signature/signature');

        if ( !(this.parent instanceof SignatureShape) ) {
            this.shapeModel.destroy();
            this.options.parent.options.channel.command('deleteShape', this.shapeModel, 1); // (true indicate the delete call is from this button)
        } else {
            //horrible quick fix for signature specific func'lity -- one sig. per note: trigger cancel creation of the note, not delete of shape -- TODO: clean
            this.options.parent.options.channel.command('cancelSignature', this.parent.pgNoteModel);
        }

    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/selectSet/btn/deleteBtn.js
 ** module id = 208
 ** module chunks = 0
 **/